// extracted by mini-css-extract-plugin
export default {"main":"LandingPageLayout_main__QHBTQ","footer":"LandingPageLayout_footer__UZK0n","footerLink":"LandingPageLayout_footerLink__DqQsl"};